<script>
    import { getContext } from 'svelte';
    import Confirm from '../components/Modal/Confirm.svelte'
    import { background, confirm } from '../stores/app'
    // import { width as windowWidth, height as windowHeight } from '../stores/bounds'
    
    export let classes;

    const isMobile = getContext ('mobileDevice');
</script>


<div 
    class="Layout {classes}" 
    class:background={$background} 
    class:confirm={$confirm} 
    class:mobile={isMobile}>
    <div class="Main">
        <slot />
    </div>

    {#if $confirm}
        <Confirm/>
    {/if}
</div>


<style>
    .Layout {
        padding: 0 0 0 50px;
    }
    .Layout.sidepanel {
        padding: 0 0 0 310px;
    }
    .Main {
        position: relative;
    }
    .Layout.mobile {
        padding: 50px 0 0 0;
    }
    .Layout.mobile.sidepanel {
        padding: 70px 0 0 0;
    }
</style>